import { useTranslation } from 'react-i18next';

export const useCountryList = () => {
  const { t } = useTranslation();

  const countries = [
    { value: 'US', text: t('countries.US') },
    { value: 'GB', text: t('countries.GB') },
    { value: 'AF', text: t('countries.AF') },
    { value: 'AX', text: t('countries.AX') },
    { value: 'AL', text: t('countries.AL') },
    { value: 'DZ', text: t('countries.DZ') },
    { value: 'AS', text: t('countries.AS') },
    { value: 'AD', text: t('countries.AD') },
    { value: 'AO', text: t('countries.AO') },
    { value: 'AI', text: t('countries.AI') },
    { value: 'AQ', text: t('countries.AQ') },
    { value: 'AG', text: t('countries.AG') },
    { value: 'AR', text: t('countries.AR') },
    { value: 'AM', text: t('countries.AM') },
    { value: 'AW', text: t('countries.AW') },
    { value: 'AU', text: t('countries.AU') },
    { value: 'AT', text: t('countries.AT') },
    { value: 'AZ', text: t('countries.AZ') },
    { value: 'BS', text: t('countries.BS') },
    { value: 'BH', text: t('countries.BH') },
    { value: 'BD', text: t('countries.BD') },
    { value: 'BB', text: t('countries.BB') },
    { value: 'BY', text: t('countries.BY') },
    { value: 'BE', text: t('countries.BE') },
    { value: 'BZ', text: t('countries.BZ') },
    { value: 'BJ', text: t('countries.BJ') },
    { value: 'BM', text: t('countries.BM') },
    { value: 'BT', text: t('countries.BT') },
    { value: 'BO', text: t('countries.BO') },
    { value: 'BQ', text: t('countries.BQ') },
    { value: 'BA', text: t('countries.BA') },
    { value: 'BW', text: t('countries.BW') },
    { value: 'BV', text: t('countries.BV') },
    { value: 'BR', text: t('countries.BR') },
    { value: 'IO', text: t('countries.IO') },
    { value: 'BN', text: t('countries.BN') },
    { value: 'BG', text: t('countries.BG') },
    { value: 'BF', text: t('countries.BF') },
    { value: 'BI', text: t('countries.BI') },
    { value: 'CV', text: t('countries.CV') },
    { value: 'KH', text: t('countries.KH') },
    { value: 'CM', text: t('countries.CM') },
    { value: 'CA', text: t('countries.CA') },
    { value: 'KY', text: t('countries.KY') },
    { value: 'CF', text: t('countries.CF') },
    { value: 'TD', text: t('countries.TD') },
    { value: 'CL', text: t('countries.CL') },
    { value: 'CN', text: t('countries.CN') },
    { value: 'CX', text: t('countries.CX') },
    { value: 'CC', text: t('countries.CC') },
    { value: 'CO', text: t('countries.CO') },
    { value: 'KM', text: t('countries.KM') },
    { value: 'CG', text: t('countries.CG') },
    { value: 'CD', text: t('countries.CD') },
    { value: 'CK', text: t('countries.CK') },
    { value: 'CR', text: t('countries.CR') },
    { value: 'CI', text: t('countries.CI') },
    { value: 'HR', text: t('countries.HR') },
    { value: 'CW', text: t('countries.CW') },
    { value: 'CY', text: t('countries.CY') },
    { value: 'CZ', text: t('countries.CZ') },
    { value: 'DK', text: t('countries.DK') },
    { value: 'DJ', text: t('countries.DJ') },
    { value: 'DM', text: t('countries.DM') },
    { value: 'DO', text: t('countries.DO') },
    { value: 'EC', text: t('countries.EC') },
    { value: 'EG', text: t('countries.EG') },
    { value: 'SV', text: t('countries.SV') },
    { value: 'GQ', text: t('countries.GQ') },
    { value: 'ER', text: t('countries.ER') },
    { value: 'EE', text: t('countries.EE') },
    { value: 'ET', text: t('countries.ET') },
    { value: 'FK', text: t('countries.FK') },
    { value: 'FO', text: t('countries.FO') },
    { value: 'FJ', text: t('countries.FJ') },
    { value: 'FI', text: t('countries.FI') },
    { value: 'FR', text: t('countries.FR') },
    { value: 'GF', text: t('countries.GF') },
    { value: 'PF', text: t('countries.PF') },
    { value: 'TF', text: t('countries.TF') },
    { value: 'GA', text: t('countries.GA') },
    { value: 'GM', text: t('countries.GM') },
    { value: 'GE', text: t('countries.GE') },
    { value: 'DE', text: t('countries.DE') },
    { value: 'GH', text: t('countries.GH') },
    { value: 'GI', text: t('countries.GI') },
    { value: 'GR', text: t('countries.GR') },
    { value: 'GL', text: t('countries.GL') },
    { value: 'GD', text: t('countries.GD') },
    { value: 'GP', text: t('countries.GP') },
    { value: 'GU', text: t('countries.GU') },
    { value: 'GT', text: t('countries.GT') },
    { value: 'GG', text: t('countries.GG') },
    { value: 'GN', text: t('countries.GN') },
    { value: 'GW', text: t('countries.GW') },
    { value: 'GY', text: t('countries.GY') },
    { value: 'HT', text: t('countries.HT') },
    { value: 'HM', text: t('countries.HM') },
    { value: 'VA', text: t('countries.VA') },
    { value: 'HN', text: t('countries.HN') },
    { value: 'HK', text: t('countries.HK') },
    { value: 'HU', text: t('countries.HU') },
    { value: 'IS', text: t('countries.IS') },
    { value: 'IN', text: t('countries.IN') },
    { value: 'ID', text: t('countries.ID') },
    { value: 'IQ', text: t('countries.IQ') },
    { value: 'IE', text: t('countries.IE') },
    { value: 'IM', text: t('countries.IM') },
    { value: 'IL', text: t('countries.IL') },
    { value: 'IT', text: t('countries.IT') },
    { value: 'JM', text: t('countries.JM') },
    { value: 'JP', text: t('countries.JP') },
    { value: 'JE', text: t('countries.JE') },
    { value: 'JO', text: t('countries.JO') },
    { value: 'KZ', text: t('countries.KZ') },
    { value: 'KE', text: t('countries.KE') },
    { value: 'KI', text: t('countries.KI') },
    { value: 'KR', text: t('countries.KR') },
    { value: 'KW', text: t('countries.KW') },
    { value: 'KG', text: t('countries.KG') },
    { value: 'LA', text: t('countries.LA') },
    { value: 'LV', text: t('countries.LV') },
    { value: 'LB', text: t('countries.LB') },
    { value: 'LS', text: t('countries.LS') },
    { value: 'LR', text: t('countries.LR') },
    { value: 'LY', text: t('countries.LY') },
    { value: 'LI', text: t('countries.LI') },
    { value: 'LT', text: t('countries.LT') },
    { value: 'LU', text: t('countries.LU') },
    { value: 'MO', text: t('countries.MO') },
    { value: 'MK', text: t('countries.MK') },
    { value: 'MG', text: t('countries.MG') },
    { value: 'MW', text: t('countries.MW') },
    { value: 'MY', text: t('countries.MY') },
    { value: 'MV', text: t('countries.MV') },
    { value: 'ML', text: t('countries.ML') },
    { value: 'MT', text: t('countries.MT') },
    { value: 'MH', text: t('countries.MH') },
    { value: 'MQ', text: t('countries.MQ') },
    { value: 'MR', text: t('countries.MR') },
    { value: 'MU', text: t('countries.MU') },
    { value: 'YT', text: t('countries.YT') },
    { value: 'MX', text: t('countries.MX') },
    { value: 'FM', text: t('countries.FM') },
    { value: 'MD', text: t('countries.MD') },
    { value: 'MC', text: t('countries.MC') },
    { value: 'MN', text: t('countries.MN') },
    { value: 'ME', text: t('countries.ME') },
    { value: 'MS', text: t('countries.MS') },
    { value: 'MA', text: t('countries.MA') },
    { value: 'MZ', text: t('countries.MZ') },
    { value: 'MM', text: t('countries.MM') },
    { value: 'NA', text: t('countries.NA') },
    { value: 'NR', text: t('countries.NR') },
    { value: 'NP', text: t('countries.NP') },
    { value: 'NL', text: t('countries.NL') },
    { value: 'NC', text: t('countries.NC') },
    { value: 'NZ', text: t('countries.NZ') },
    { value: 'NI', text: t('countries.NI') },
    { value: 'NE', text: t('countries.NE') },
    { value: 'NG', text: t('countries.NG') },
    { value: 'NU', text: t('countries.NU') },
    { value: 'NF', text: t('countries.NF') },
    { value: 'MP', text: t('countries.MP') },
    { value: 'NO', text: t('countries.NO') },
    { value: 'OM', text: t('countries.OM') },
    { value: 'PK', text: t('countries.PK') },
    { value: 'PW', text: t('countries.PW') },
    { value: 'PS', text: t('countries.PS') },
    { value: 'PA', text: t('countries.PA') },
    { value: 'PG', text: t('countries.PG') },
    { value: 'PY', text: t('countries.PY') },
    { value: 'PE', text: t('countries.PE') },
    { value: 'PH', text: t('countries.PH') },
    { value: 'PN', text: t('countries.PN') },
    { value: 'PL', text: t('countries.PL') },
    { value: 'PT', text: t('countries.PT') },
    { value: 'PR', text: t('countries.PR') },
    { value: 'QA', text: t('countries.QA') },
    { value: 'RE', text: t('countries.RE') },
    { value: 'RO', text: t('countries.RO') },
    { value: 'RU', text: t('countries.RU') },
    { value: 'RW', text: t('countries.RW') },
    { value: 'BL', text: t('countries.BL') },
    { value: 'SH', text: t('countries.SH') },
    { value: 'KN', text: t('countries.KN') },
    { value: 'LC', text: t('countries.LC') },
    { value: 'MF', text: t('countries.MF') },
    { value: 'PM', text: t('countries.PM') },
    { value: 'VC', text: t('countries.VC') },
    { value: 'WS', text: t('countries.WS') },
    { value: 'SM', text: t('countries.SM') },
    { value: 'ST', text: t('countries.ST') },
    { value: 'SA', text: t('countries.SA') },
    { value: 'SN', text: t('countries.SN') },
    { value: 'RS', text: t('countries.RS') },
    { value: 'SC', text: t('countries.SC') },
    { value: 'SL', text: t('countries.SL') },
    { value: 'SG', text: t('countries.SG') },
    { value: 'SX', text: t('countries.SX') },
    { value: 'SK', text: t('countries.SK') },
    { value: 'SI', text: t('countries.SI') },
    { value: 'SB', text: t('countries.SB') },
    { value: 'SO', text: t('countries.SO') },
    { value: 'ZA', text: t('countries.ZA') },
    { value: 'GS', text: t('countries.GS') },
    { value: 'SS', text: t('countries.SS') },
    { value: 'ES', text: t('countries.ES') },
    { value: 'LK', text: t('countries.LK') },
    { value: 'SD', text: t('countries.SD') },
    { value: 'SR', text: t('countries.SR') },
    { value: 'SJ', text: t('countries.SJ') },
    { value: 'SZ', text: t('countries.SZ') },
    { value: 'SE', text: t('countries.SE') },
    { value: 'CH', text: t('countries.CH') },
    { value: 'TW', text: t('countries.TW') },
    { value: 'TJ', text: t('countries.TJ') },
    { value: 'TZ', text: t('countries.TZ') },
    { value: 'TH', text: t('countries.TH') },
    { value: 'TL', text: t('countries.TL') },
    { value: 'TG', text: t('countries.TG') },
    { value: 'TK', text: t('countries.TK') },
    { value: 'TO', text: t('countries.TO') },
    { value: 'TT', text: t('countries.TT') },
    { value: 'TN', text: t('countries.TN') },
    { value: 'TR', text: t('countries.TR') },
    { value: 'TM', text: t('countries.TM') },
    { value: 'TC', text: t('countries.TC') },
    { value: 'TV', text: t('countries.TV') },
    { value: 'UG', text: t('countries.UG') },
    { value: 'UA', text: t('countries.UA') },
    { value: 'AE', text: t('countries.AE') },
    { value: 'UM', text: t('countries.UM') },
    { value: 'UY', text: t('countries.UY') },
    { value: 'UZ', text: t('countries.UZ') },
    { value: 'VU', text: t('countries.VU') },
    { value: 'VE', text: t('countries.VE') },
    { value: 'VN', text: t('countries.VN') },
    { value: 'VG', text: t('countries.VG') },
    { value: 'VI', text: t('countries.VI') },
    { value: 'WF', text: t('countries.WF') },
    { value: 'EH', text: t('countries.EH') },
    { value: 'YE', text: t('countries.YE') },
    { value: 'ZM', text: t('countries.ZM') },
    { value: 'ZW', text: t('countries.ZW') },
  ];

  const states = {
    US: [
      { value: 'AL', text: t('states.US.AL') },
      { value: 'AK', text: t('states.US.AK') },
      { value: 'AZ', text: t('states.US.AZ') },
      { value: 'AR', text: t('states.US.AR') },
      { value: 'CA', text: t('states.US.CA') },
      { value: 'CO', text: t('states.US.CO') },
      { value: 'CT', text: t('states.US.CT') },
      { value: 'DE', text: t('states.US.DE') },
      { value: 'FL', text: t('states.US.FL') },
      { value: 'GA', text: t('states.US.GA') },
      { value: 'HI', text: t('states.US.HI') },
      { value: 'ID', text: t('states.US.ID') },
      { value: 'IL', text: t('states.US.IL') },
      { value: 'IN', text: t('states.US.IN') },
      { value: 'IA', text: t('states.US.IA') },
      { value: 'KS', text: t('states.US.KS') },
      { value: 'KY', text: t('states.US.KY') },
      { value: 'LA', text: t('states.US.LA') },
      { value: 'ME', text: t('states.US.ME') },
      { value: 'MD', text: t('states.US.MD') },
      { value: 'MA', text: t('states.US.MA') },
      { value: 'MI', text: t('states.US.MI') },
      { value: 'MN', text: t('states.US.MN') },
      { value: 'MS', text: t('states.US.MS') },
      { value: 'MO', text: t('states.US.MO') },
      { value: 'MT', text: t('states.US.MT') },
      { value: 'NE', text: t('states.US.NE') },
      { value: 'NV', text: t('states.US.NV') },
      { value: 'NH', text: t('states.US.NH') },
      { value: 'NJ', text: t('states.US.NJ') },
      { value: 'NM', text: t('states.US.NM') },
      { value: 'NY', text: t('states.US.NY') },
      { value: 'NC', text: t('states.US.NC') },
      { value: 'ND', text: t('states.US.ND') },
      { value: 'OH', text: t('states.US.OH') },
      { value: 'OK', text: t('states.US.OK') },
      { value: 'OR', text: t('states.US.OR') },
      { value: 'PA', text: t('states.US.PA') },
      { value: 'RI', text: t('states.US.RI') },
      { value: 'SC', text: t('states.US.SC') },
      { value: 'SD', text: t('states.US.SD') },
      { value: 'TN', text: t('states.US.TN') },
      { value: 'TX', text: t('states.US.TX') },
      { value: 'UT', text: t('states.US.UT') },
      { value: 'VT', text: t('states.US.VT') },
      { value: 'VA', text: t('states.US.VA') },
      { value: 'WA', text: t('states.US.WA') },
      { value: 'DC', text: t('states.US.DC') },
      { value: 'WV', text: t('states.US.WV') },
      { value: 'WI', text: t('states.US.WI') },
      { value: 'WY', text: t('states.US.WY') },
    ],
  };

  const GDPRCountryCodes = [
    'AT',
    'BE',
    'BG',
    'HR',
    'CY',
    'CZ',
    'DK',
    'EE',
    'FI',
    'FR',
    'DE',
    'GR',
    'HU',
    'IE',
    'IT',
    'LV',
    'LT',
    'LU',
    'MT',
    'NL',
    'PL',
    'PT',
    'RO',
    'SK',
    'SI',
    'ES',
    'SE',
    'IS',
    'LI',
    'NO',
    'CH',
    'GB',
  ];

  const EUVATCountryCodes = [
    'AT',
    'BE',
    'BG',
    'CY',
    'CZ',
    'DE',
    'DK',
    'EE',
    'ES',
    'FI',
    'FR',
    'GR',
    'HR',
    'HU',
    'IE',
    'IT',
    'LT',
    'LU',
    'LV',
    'MT',
    'NL',
    'PL',
    'PT',
    'RO',
    'SE',
    'SI',
    'SK',
  ];

  return { countries, states, GDPRCountryCodes, EUVATCountryCodes };
};
